import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import moment from 'moment';

import DatePicker from '../../core/components/DatePicker';

type Props = {
  startDate: string;
  handleDateChange: (date: moment.Moment) => void;
};

const VtourDate = React.memo((props: Props) => {
  const style: { [key: string]: React.CSSProperties } = {
    div: {},
    text: {
      fontWeight: 'bold',
      marginBottom: '4px',
    },
    error: {
      marginTop: '4px',
      fontSize: '14px',
      color: '#f44336',
    },
  };

  const [selectedDate, setSelectedDate] = useState(
    new Date(props.startDate || new Date()),
  );
  const handleDateChange = React.useCallback(
    (date: Date) => {
      const startDate = moment(date);
      props.handleDateChange(startDate);
    },
    [props],
  );
  React.useEffect(() => {
    handleDateChange(selectedDate);
  }, [selectedDate]);

  return (
    <div style={style.div}>
      <span style={style.text}>
        <FormattedMessage id="VtourDate.DateAndTime" />
      </span>
      <div>
        <DatePicker
          selectedDate={selectedDate}
          setSelectedDate={setSelectedDate}
        />
      </div>
    </div>
  );
});

export default VtourDate;
